import {
  Button,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  FormControl,
  FormLabel,
} from '@chakra-ui/react'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import { DialogDrawer } from '@/components/shared/bundles/Drawer'
import { Inputs } from '@/components/shared/forms/Inputs'
import { Repository } from '@/services/repository'

import { useGetCallDetails } from '../../hooks/get-callDetails'

interface Props {
  callId: number
  initialDescription: string
  onSuccess: (data: any) => void
}

export default function Component({
  callId,
  initialDescription,
  onSuccess,
}: Props) {
  const { invalidateCallDetails } = useGetCallDetails(callId)

  const form = useForm({
    defaultValues: { description: '' },
  })

  useEffect(() => {
    form.reset({ description: initialDescription })
  }, [initialDescription])

  const cancelHandler = form.handleSubmit(async ({ description }) => {
    if (!description) return

    try {
      const res = await Repository.Entity.Call.Cancel({
        id: callId,
        cancelDescription: description,
      })
      toast.success('Chamado cancelado com sucesso')
      onSuccess(res)
      invalidateCallDetails()
    } catch (error: any) {
      toast.error(error.message)
    }
  })

  const closeHandler = form.handleSubmit(async ({ description }) => {
    if (!description) return

    try {
      const res = await Repository.Entity.Call.End({
        id: callId,
        clientDescription: description,
      })
      toast.success('Chamado encerrado com sucesso')
      onSuccess(res)
      invalidateCallDetails()
    } catch (error: any) {
      toast.error(error.message)
    }
  })

  return (
    <DialogDrawer>
      <form>
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Encerrar chamado</DrawerHeader>
          <DrawerBody>
            <FormControl isRequired>
              <FormLabel>Descrição</FormLabel>
              <Inputs.Textarea useForm={form} useFormField="description" />
            </FormControl>
          </DrawerBody>
          <DrawerFooter justifyContent="space-between">
            <Button colorScheme="red" onClick={cancelHandler}>
              Cancelar
            </Button>
            <Button colorScheme="primary" onClick={closeHandler}>
              Encerrar
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </form>
    </DialogDrawer>
  )
}
